module.exports = __webpack_public_path__ + "static/media/arya_wankhede.3568e6a1.png";